module.exports = __webpack_public_path__ + "img/photo2_5.cc5d215c.jpg";